import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { TransfersPage } from './_dashboard.inventory.transfers'

export const Route = createFileRoute('/_dashboard/inventory/transfers/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TransfersItemPage,
})

function TransfersItemPage() {
  const { item } = Route.useParams()
  return <TransfersPage selectedId={item} />
}
